export default "__VITE_ASSET__CxytoM5N__"